import { isSafeRedirect } from '@/utils/index.js'
export const itemClick = {
    methods: {
        swiperClick(v) {
            console.log(v)
            // type 1 url 直接跳转
            // 2 商品
            //  3 文章
            // 4  文章分类
            // 5 智能表单
          // window.open('https://www.baidu.com','_blank')
			if (v.type == 1 && v.val!='#') {
              if (isSafeRedirect(v.val)) {
                window.open(v.val,'_blank')
              }
              return
            }
            if(v.type == 2) {
              this.$router.push({
                path: `detail/${v.id}`,
              })
              return
            }
          },
    }
}